import OverflowText from "../../../../components/overflow-text/overflow-text";
import {
  Badge,
  CardContainer,
  Footer,
  Header,
  PetsCount,
} from "./shift-card.styles";
import { Divider, Typography } from "@mui/material";

type CardProps = {
  name: string;
  time: string;
  address: string;
  petsCount: number;
  status?: "ongoing" | "onMyWay";
  onClick?: () => void;
  onMyWayHandler?: () => void;
};

const ShiftCard: React.FC<CardProps> = ({
  name,
  time,
  address,
  petsCount,
  status = "onMyWay",
  onClick,
  onMyWayHandler,
}) => {
  return (
    <CardContainer status={status} onClick={onClick}>
      <div>
        <Header>
          <div className="title-wrapper">
            <Typography variant="h2">{name}</Typography>
            <Typography className="time" variant="h6">
              {time}
            </Typography>
          </div>
          {status === "ongoing" && <Badge status="ongoing">Ongoing</Badge>}
          {status === "onMyWay" && (
            <Badge status="onMyWay" onClick={onMyWayHandler}>
              On My Way
            </Badge>
          )}
        </Header>
      </div>
      <div className="divider-wrapper">
        <Divider />
      </div>
      <div className="footer">
        <Footer>
          <span>Address</span>
          <OverflowText>{address}</OverflowText>
        </Footer>
        <Footer>
          <span>No. of pets</span>
          <PetsCount>{petsCount?.toString()?.padStart(2, "0")}</PetsCount>
        </Footer>
      </div>
    </CardContainer>
  );
};

export default ShiftCard;
